import React, { FC } from 'react'

import { Box } from '@material-ui/core'

import { PlayerProfileResponse, ScoringItem, MatchStatus } from 'protos'
import T from 'components/FormattedMessage'
import { playerProfilePalette } from 'lib'

import { ScoreItemList, PointspreadGraph } from './components'
import { PlayerProfileEmpty } from '../../components'

import playerPerformanceIconUrl from './assets/icon-performance.svg'
import teamBonusIconUrl from './assets/icon-team-bonus.svg'
import penaltiesIconUrl from './assets/icon-penalties.svg'

type Props = {
  profile: PlayerProfileResponse
}

const isPlayerPerformance = (item: ScoringItem) => !item.bonus && item.totalValue > 0
const isTeamBonus = (item: ScoringItem) => !!item.bonus && item.totalValue > 0
const isPenalty = (item: ScoringItem) => item.totalValue < 0

const PointspreadTab: FC<Props> = ({ profile }) => {
  if (!profile.currentMatch || profile.currentMatch.status === MatchStatus.MS_UPCOMING) {
    return (
      <PlayerProfileEmpty />
    )
  }

  const {
    playerPerformance,
    totalPlayerPerformance,
    teamBonus,
    totalTeamBonus,
    penalties,
    totalPenalties,
  } = (profile.scoreItem as ScoringItem[]).reduce(
    (acc, item) => {
      const totalValue = item.totalValue || 0

      if (isPenalty(item)) {
        acc.penalties.push(item)
        acc.totalPenalties += totalValue
      }

      if (isTeamBonus(item)) {
        acc.teamBonus.push(item)
        acc.totalTeamBonus += totalValue
      }

      if (isPlayerPerformance(item)) {
        acc.playerPerformance.push(item)
        acc.totalPlayerPerformance += totalValue
      }

      return acc
    },
    {
      playerPerformance: [] as ScoringItem[],
      totalPlayerPerformance: 0,
      teamBonus: [] as ScoringItem[],
      totalTeamBonus: 0,
      penalties: [] as ScoringItem[],
      totalPenalties: 0,
    }
  )

  return (
    <>
      <Box
        my={{
          xs: 3,
          sm: 4,
        }}
        mx={{
          xs: 2,
          sm: 3,
        }}
      >
        <PointspreadGraph
          totalPlayerPerformance={totalPlayerPerformance}
          totalTeamBonus={totalTeamBonus}
          totalPenalties={totalPenalties}
        />
      </Box>

      <ScoreItemList
        title={<T id="playerprofile_player_performance" />}
        icon={<img src={playerPerformanceIconUrl} alt="" />}
        color={playerProfilePalette.playerPerformance[0]}
        total={totalPlayerPerformance}
        items={playerPerformance}
      />

      <ScoreItemList
        title={<T id="playerprofile_team_bonus" />}
        icon={<img src={teamBonusIconUrl} alt="" />}
        color={playerProfilePalette.teamBonus[1]}
        total={totalTeamBonus}
        items={teamBonus}
      />

      <ScoreItemList
        title={<T id="playerprofile_penalties" />}
        icon={<img src={penaltiesIconUrl} alt="" />}
        color={playerProfilePalette.penalties[1]}
        total={totalPenalties}
        items={penalties}
      />
    </>
  )
}

export default PointspreadTab
try {
    // @ts-ignore
    PointspreadTab.displayName = "PointspreadTab";
    // @ts-ignore
    PointspreadTab.__docgenInfo = { "description": "", "displayName": "PointspreadTab", "props": { "profile": { "defaultValue": null, "description": "", "name": "profile", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/tabs/PointspreadTab/PointspreadTab.tsx#PointspreadTab"] = { docgenInfo: PointspreadTab.__docgenInfo, name: "PointspreadTab", path: "src/components/PlayerLayer/components/PlayerProfile/tabs/PointspreadTab/PointspreadTab.tsx#PointspreadTab" };
}
catch (__react_docgen_typescript_loader_error) { }